/*
* 验证身份证号
* */
export function checkIdNum(rule, value, callback) {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  if (!value) {
    return callback(new Error('身份证件号码不能为空'))
  } else if (!reg.test(value)) {
    return callback(new Error('身份证件号码不正确'))
  } else {
    callback()
  }
}
/*
* 验证手机号
* */
export function checkTelNum(rule, value, callback) {
  const reg = /^1[0-9]{10}$/;
  if (!value) {
    return callback(new Error('手机号码不能为空'))
  } else if (!reg.test(value)) {
    return callback(new Error('手机号码不正确'))
  } else {
    callback()
  }
}

export function checkTelNumTwo(rule, value, callback) {
  const reg = /^1[0-9]{10}$/;
  if (!value) {
    callback()
  } else if (!reg.test(value)) {
    return callback(new Error('手机号码不正确'))
  } else {
    callback()
  }
}

export default {
  idCard: [{ required: true, validator: checkIdNum, trigger: 'blur' }],
  phone: [{ required: true, validator: checkTelNum, trigger: 'blur' }],
  phone2: [{ required: true, validator: checkTelNumTwo, trigger: 'blur' }]
}
